import { Component, Input } from '@angular/core';
import { Yii } from 'libraries/interfaces/Yii';
import {
    EQuoteExchangeRuleValidityCountingFrom,
    IAirTripQuoteCurrency,
    IQuoteExchangeRule
} from "libraries/service/resources/airTrip/IGetAirTripQuotes";

export enum EPenaltyType {
    exchange = 'exchange',
    cancellation = 'cancellation',
}

class PenaltyWording {
    public [EPenaltyType.exchange]: string = Yii.t('wui-shared-js', 'Échange : ');
    public [EPenaltyType.cancellation]: string = Yii.t('wui-shared-js', 'Annulation : ');
}

class CountingFromWording {
    public penaltyWording: PenaltyWording = new PenaltyWording();
    public [EPenaltyType.exchange]: {[key: string]: string} = {
        [EQuoteExchangeRuleValidityCountingFrom.AfterDeparture]: Yii.t('wui-shared-js', 'Échange apr dép. : '),
        [EQuoteExchangeRuleValidityCountingFrom.BeforeDeparture]: Yii.t('wui-shared-js', 'Échange avt dép. : '),
        [EQuoteExchangeRuleValidityCountingFrom.AfterBooking]: this.penaltyWording[EPenaltyType.exchange],
    };
    public [EPenaltyType.cancellation]: {[key: string]: string} = {
        [EQuoteExchangeRuleValidityCountingFrom.AfterDeparture]: Yii.t('wui-shared-js', 'Annulation apr dép : '),
        [EQuoteExchangeRuleValidityCountingFrom.BeforeDeparture]: Yii.t('wui-shared-js', 'Annulation avt dép. : '),
        [EQuoteExchangeRuleValidityCountingFrom.AfterBooking]: this.penaltyWording[EPenaltyType.cancellation],
    };

}

@Component({
    selector: 'exchange',
    template: `
        <ng-container *ngIf="penaltyArray?.length">
            <div *ngFor="let rule of penaltyArray">
                <ng-container *ngIf="rule?.validity?.countingFrom; else noCountingFrom">
                    <span>{{countingFromWording[type][rule.validity.countingFrom]}}</span>
                </ng-container>
                <ng-template #noCountingFrom>
                    <span>{{penaltyWording[type]}}</span>
                </ng-template>
                <span *ngIf="rule?.penalty?.percentage || rule?.penalty?.percentage === 0; else price">
                    {{rule.penalty.percentage}}%
                </span>
                <ng-template #price>
                    <span><price [currency]="currency.code" [value]="rule?.penalty" type="light"></price></span>
                </ng-template>
            </div>
        </ng-container>

    `
})
export class ExchangeComponent {

    @Input()
    public penaltyArray: IQuoteExchangeRule[];

    @Input()
    public type: EPenaltyType;
    @Input()
    public validity: EQuoteExchangeRuleValidityCountingFrom;

    @Input()
    public currency: IAirTripQuoteCurrency;


    public penaltyWording: PenaltyWording = new PenaltyWording();
    public countingFromWording: CountingFromWording = new CountingFromWording();
}
